import { useDispatch } from "react-redux";
import { createSearchParams, useNavigate } from "react-router-dom";
import { makeLangUrl } from "helpers/makeLangUrl";

// Actions
import { setCategory, setProviderPage } from "redux/game/slice";

// Components
import FooterNavigationItem from "components/atoms/FooterNavigationItem";

// Constants
import { CATEGORIES_ENUMS } from "constants/navigation/categories";
import { NAVIGATION_PROPERTIES } from "constants/navigation/topNavigationDesktop";
import { GET_PARAMS } from "constants/popupConfig";
import {
  FOOTER_NAVIGATION_ENUMS,
  FooterNavigationType,
} from "constants/navigation";

// Hooks
import { useLoadGame } from "hooks/useLoadGame";
import { useGTM } from "hooks/useGTM";
import { useCheckBalance } from "hooks/useCheckBalance";

// Types
import { GAME_MODE } from "types/Games";
import { ALIAS_GAME } from "types/Banners";

// Url
import urlRoutes from "url/index";

type FooterNavigationItemContainerProps = {
  item: FooterNavigationType;
};

const FooterNavigationItemContainer = (
  props: FooterNavigationItemContainerProps,
) => {
  const { item } = props;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // eslint-disable-next-line unused-imports/no-unused-vars
  const [loadGame, { isLoading }] = useLoadGame();
  const GTM = useGTM();
  const checkBalance = useCheckBalance();

  async function handleGameInit(urlAlias: string) {
    await loadGame(GAME_MODE.REAL, urlAlias);
  }

  const handleClick = () => {
    if (item.id === FOOTER_NAVIGATION_ENUMS.ABOUT) {
      GTM.infoAboutUs();
    }
    if (item.id === FOOTER_NAVIGATION_ENUMS.CONDITIONS) {
      GTM.infoTerms();
    }
    if (item.id === FOOTER_NAVIGATION_ENUMS.KYCAML) {
      GTM.infoKYC();
    }
    if (item.id === FOOTER_NAVIGATION_ENUMS.PRIVACY) {
      GTM.infoPrivacy();
    }
    if (item.id === FOOTER_NAVIGATION_ENUMS.GAMBLING) {
      GTM.infoResponsable();
    }
    if (item.id === FOOTER_NAVIGATION_ENUMS.COOKIES) {
      GTM.infoCookies();
    }

    if (item.id === FOOTER_NAVIGATION_ENUMS.LIVE) {
      GTM.clickLiveCasinoDesktop();
    }
    if (item.id === FOOTER_NAVIGATION_ENUMS.AVIATOR) {
      GTM.clickAviator();
      const isBalancePositive = checkBalance();
      if (isBalancePositive) {
        navigate({
          pathname: makeLangUrl(
            urlRoutes.routes.casino.game({ game: ALIAS_GAME.AVIATOR }),
          ),
          search: `?${createSearchParams({
            [GET_PARAMS.MODE]: GAME_MODE.REAL,
          })}`,
        });
      }
    }
    if (item.id === FOOTER_NAVIGATION_ENUMS.WELCOME_BONUS) {
      GTM.clickBonusProgramm();
    }
    if (item.id === FOOTER_NAVIGATION_ENUMS.TOURNAMENTS) {
      GTM.clickTournaments();
    }
    if (item.gameId) {
      handleGameInit(item.gameId);
    }
    if (item.link) {
      navigate(makeLangUrl(item.link));
    }
    // eslint-disable-next-line sonarjs/no-collapsible-if
    if (item.property) {
      // eslint-disable-next-line sonarjs/no-collapsible-if
      if (item.property === NAVIGATION_PROPERTIES.PROVIDER) {
        if (item.value) {
          dispatch(setProviderPage(item.value.join(",")));
          dispatch(setCategory(CATEGORIES_ENUMS.POPULAR));
        }
      }
    }
  };

  return <FooterNavigationItem item={item} onClick={handleClick} />;
};

export default FooterNavigationItemContainer;
